// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: shared/api/common/ENUM_PropertyClosedReason.proto

export enum ENUM_PropertyClosedReason {
  PROPERTY_CLOSED_REASON_UNSPECIFIED = 'PROPERTY_CLOSED_REASON_UNSPECIFIED',
  PROPERTY_CLOSED_REASON_PROPERTY_SOLD = 'PROPERTY_CLOSED_REASON_PROPERTY_SOLD',
  PROPERTY_CLOSED_REASON_CLOSED_WITH_NEW_PROPERTY = 'PROPERTY_CLOSED_REASON_CLOSED_WITH_NEW_PROPERTY',
  PROPERTY_CLOSED_REASON_LOST_BUSINESS = 'PROPERTY_CLOSED_REASON_LOST_BUSINESS',
  PROPERTY_CLOSED_REASON_LOST_BUSINESS__TRANSFERRED_WITH_EXISTING_LENDER = 'PROPERTY_CLOSED_REASON_LOST_BUSINESS__TRANSFERRED_WITH_EXISTING_LENDER',
  PROPERTY_CLOSED_REASON_LOST_BUSINESS__DIRECT_TO_LENDER = 'PROPERTY_CLOSED_REASON_LOST_BUSINESS__DIRECT_TO_LENDER',
  PROPERTY_CLOSED_REASON_LOST_BUSINESS__TO_ANOTHER_BROKER = 'PROPERTY_CLOSED_REASON_LOST_BUSINESS__TO_ANOTHER_BROKER',
  PROPERTY_CLOSED_REASON_OTHER = 'PROPERTY_CLOSED_REASON_OTHER',
  UNRECOGNIZED = 'UNRECOGNIZED',
}
